const probenarten = [
	"14C",
	"Dendrodaten",
	"Holzartenbestimmung",
	"Geologie",
	"Mikrostratigraphie",
	"Pollenanalyse",
	"Makroreste (bot.)",
	"Mollusken/Insekten",
	"Moertel / Putz",
	"Archaeomagnetik",
	"OSL",
	"TL",
	"RFA",
	"Petrografie",
	"Phosphat",
	"Bodenprobe allg.",
	"Lehmprobe"
]

export default probenarten;
